/**
 * Should not be added directly to components but through the specific user type container e.g AdminParentContainerComponent...
 */
import { StoreProvider } from 'easy-peasy'
import React from 'react'
import MySnackbarComponent from '../../components/SnackbarComponents/MySnackbarComponent'
import { GlobalStore } from '../../store/globalStore'
import { useIsSmallScreen } from '../../components/utilsHooks/useIsSmallScreen'
import { Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useUserAuthStatus from '../../components/Auhentication/useUserAuthStatus'
import PageLoadingComponent from '../../components/LoadingComponents/PageLoadingComponent'
import { useSchoolDetails } from '../../hooks/useSchoolDetails'

const AccessMediaQueryMethod = (props: { children: React.ReactNode }) => {
  const isSmallScreenHook = useIsSmallScreen()
  const theme = useTheme()
  const componentMounted = React.useRef(false)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

  React.useEffect(() => {
    if (!componentMounted.current) {
      componentMounted.current = true
    }
  }, [])

  React.useEffect(() => {
    console.log({ isSmallScreen })
    isSmallScreenHook.initialiseIsSmallScreen(isSmallScreen)
  }, [componentMounted.current])

  return <>{props.children}</>
}

const AuthStatusContainer = (props: any) => {
  const [authStatusLoaded, setAuthStatusLoaded] = React.useState(false)
  const [authStatusError, setAuthStatusError] = React.useState(false)
  const userAuthHook = useUserAuthStatus()
  const { loading: schoolLoading } = useSchoolDetails()

  React.useEffect(() => {
    refreshSchoolUserAuthStatus()
  }, [])

  const refreshSchoolUserAuthStatus = async () => {
    try {
      setAuthStatusLoaded(false)
      setAuthStatusError(false)
      await userAuthHook.refreshSchoolUserDetails()
      setAuthStatusLoaded(true)
      setAuthStatusError(false)
    } catch (err) {
      console.log(err)
      setAuthStatusLoaded(false)
      setAuthStatusError(true)
    }
  }

  if (authStatusError && !authStatusLoaded) {
    return (
      <div style={{ textAlign: 'center', maxWidth: '1000px', margin: 'auto' }}>
        <div>
          <img
            style={{
              marginTop: '60px',
            }}
            width="300px"
            // height="120px"
            src="/static/img/asset_empty.svg"
          />
        </div>
        <Typography
          style={{ marginTop: '50px', fontWeight: 'bold' }}
          variant={'h5'}
        >
          Ooops! An error occured
        </Typography>
        <Typography variant={'body1'} style={{ padding: '10px' }}>
          Please refresh page
        </Typography>
        {/* <Button variant={'contained'} href={'/'} color={'primary'}>
          Back to home
        </Button> */}
      </div>
    )
  }

  if (!authStatusLoaded || schoolLoading) {
    return <PageLoadingComponent />
  }

  return <>{props.children}</>
}

const GlobalClientDashboardContainer = (props: any) => {
  return (
    <>
      <StoreProvider store={GlobalStore}>
        <AuthStatusContainer>
          <AccessMediaQueryMethod>{props.children}</AccessMediaQueryMethod>
          <MySnackbarComponent />
        </AuthStatusContainer>
      </StoreProvider>
    </>
  )
}

export default GlobalClientDashboardContainer
